import Cookies from 'js-cookie'


export function clearUserCache() {
  removeUserTid()
  removeToken()
  removeAccount()
  removeName()
}

// 用户Token
const TokenKey = 'User-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 用户TID
const UserTidKey = 'User-Tid'

export function getUserTid() {
  return Cookies.get(UserTidKey)
}
export function setUserTid(UserTid) {
  return Cookies.set(UserTidKey, UserTid)
}
export function removeUserTid() {
  return Cookies.remove(UserTidKey)
}

// 用户账号
const AccountKey = 'User-Account'

export function getAccount() {
  return Cookies.get(AccountKey)
}
export function setAccount(account) {
  return Cookies.set(AccountKey, account)
}
export function removeAccount() {
  return Cookies.remove(AccountKey)
}

// 用户昵称
const NameKey = 'User-Name'

export function getName() {
  return Cookies.get(NameKey)
}
export function setName(name) {
  return Cookies.set(NameKey, name)
}
export function removeName() {
  return Cookies.remove(NameKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js